<template>

    <v-card outlined style="border: 1px solid #DDDDDD; border-radius: 8px;">
        <v-card-text class="pa-2">
            <div class="ma-0 d-flex" style="justify-content: space-between; padding: 20px 10px;">
                <div class="d-flex justify-start flex-column">
                    <small style="color: #757575; font-size: 14px;">{{ $t('wkt.client.expensesheets.detail-window.creation_date') }}</small>
                    <span class="black--text" style="font-size: 18px;">{{ formatLongDate(data.creationDate) }}</span>
                </div>
                <div class="d-flex justify-start flex-column">
                    <small style="color: #757575; font-size: 14px;">{{ $t('wkt.client.expensesheets.detail-window.project') }}</small>
                    <span class="black--text text-truncate" style="font-size: 18px;">{{ data.projectName ? data.projectName : '--' }}</span>
                </div>
                <div class="d-flex justify-start flex-column">
                    <small style="color: #757575; font-size: 14px;">{{ $t('wkt.client.expensesheets.detail-window.status') }}</small>                                        
                    <span :style="`font-size: 18px; display: block; white-space: nowrap; color: ${getStatusColor(data.status)}`">{{ getStatusText(data.status) }}</span>
                </div>
                <div class="d-flex justify-start flex-column">
                    <small style="color: #757575; font-size: 14px;">{{ $t('wkt.client.expensesheets.detail-window.amount') }}</small>
                    <h3 class="black--text" style="font-size: 18px;">{{ formatCurrency(data.amount) }}</h3>
                </div>
                <div class="mt-1 d-flex align-center justify-end">
                    <v-btn v-if="[-1,2].includes(data.status)" text color="#185EA9" @click="$emit('edit-expense-sheet')">{{ $t('wkt.client.expensesheets.detail-window.button-edit') }}</v-btn>                                        
                    <v-btn v-if="[-1,2].includes(data.status)" text color="#185EA9" :disabled="!hasItems" @click="$emit('confirm-send-expense-sheet')">{{ $t('wkt.client.expensesheets.detail-window.button-send') }}</v-btn>
                    <v-btn v-if="[0].includes(data.status)" :disabled="!isEmployeeCreator" text color="#185EA9" @click="$emit('cancel-expense-sheet-request')">{{ $t('wkt.client.expensesheets.detail-window.button-cancel_request') }}</v-btn>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script> 
import BaseModule from '../../common/BaseModule.js'

export default {
    name: 'ExpenseSheetDesktopHeader',
    mixins: [BaseModule],
    props: ['data','employeeId','hasItems'],
    computed: {
        isEmployeeCreator() {
            return this.employeeId && this.employeeId === this.data.creatorId;
        }
    },
    methods: {
        onWheel(event) {
            event.stopPropagation();
        },
    }
};
</script>
